// extracted by mini-css-extract-plugin
export default {"inlineCollapsible":"OquaH","inlineCollapsible--expanded":"QlYdZ"};